import { createFileRoute, Outlet } from "@tanstack/react-router";
import { z } from "zod";
import { useHasPermission } from "~/hooks/useHasPermission";
import { ByggeRadarPaywallPage } from "~/routes/(restricted)/byggeradar/-components/ByggeRadarPaywallPage";
import { ByggeRadarOnboarding } from "~/routes/(restricted)/byggeradar/-components/onboarding/ByggeRadarOnboarding";
import { useByggeRadarPersonProperties } from "~/routes/(restricted)/byggeradar/-hooks/useByggeRadarPersonProperties";
import { AppPermission } from "~/utils/permissions";

const searchSchema = z.object({
  session_id: z.string().optional(),
});

export const Route = createFileRoute("/(restricted)/byggeradar/_access")({
  component: ByggeradarAccessLayout,
  validateSearch: searchSchema,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces("checkout");

    const title = i18n.t("checkout:meta.title");

    return { meta: { title } };
  },
  head: async (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});

function ByggeradarAccessLayout() {
  const hasByggeRadarPermission = useHasPermission(
    AppPermission.planningProposal,
  );

  useByggeRadarPersonProperties(hasByggeRadarPermission);

  if (!hasByggeRadarPermission) return <ByggeRadarPaywallPage />;

  return (
    <>
      <Outlet />
      <ByggeRadarOnboarding />
    </>
  );
}
